$(document).ready(function(){
	
	if(!document.querySelector('.reporting-step-area')) return false;
	
	var el = $('#reporting-form');
	var complaintsChooseReplyValue = $(el).find('input[name="objects-1"]:checked').val();
	var form = {
			file: $(el).find('#file'),
			email: $(el).find('#report-email'), 
			tel: $(el).find('#report-tel'), 
			title: $(el).find('#report-title'),
			contents: $(el).find('#report-contents'),
			submitBtn: $(el).find('#complaints_submit_btn'),
			cancelBtn: $(el).find('#complaints_cancel_btn'),
			telRequiredErrorMsg : $(el).find('#report-tel').siblings('.error-msg').find('span.required'),
			telInputErrorMsg : $(el).find('#report-tel').siblings('.error-msg').find('span.invalid-number'),
			telInputEmptyErrorMsg : $(el).find('#report-tel').siblings('.error-msg').find('span.input-empty'),
			emailRequiredErrorMsg : $(el).find('#report-email').siblings('.error-msg').find('span.required'),
			emailInputErrorMsg : $(el).find('#report-email').siblings('.error-msg').find('span.invalid-email'),
			emailInputEmptyErrorMsg : $(el).find('#report-email').siblings('.error-msg').find('span.input-empty'),
			radio :{
				chooseReply : $(el).find('input[name="objects-1"]'),
			},
	};
	var modals = {
		submitModal: {
			submitCheckModal: $('#modal_CustomerComplaints'),
			submitSuccessModal: $('#modal_report_successfully')
		},
		cancelModal: {
			cancelCheckModal: $('#modal_cancel_confirm'),
			cancelSuccessModal: $('#modal_reception_cancel')
		}
	};
	var modalsBtn= {
		submitCheckConfirmBtn: $(modals.submitModal.submitCheckModal).find('#completed1ConfirmBtn'),
		submitCheckCancelBtn: $(modals.submitModal.submitCheckModal).find('#completed1CancelBtn'),
		submitSuccessedBtn: $(modals.submitModal.submitSuccessModal).find('#completed2HomeBtn'),
		cancelCheckConfirmBtn: $(modals.cancelModal.cancelCheckModal).find('#cancelConfirm-ConfirmBtn'),
		cancelCheckCancelBtn: $(modals.cancelModal.cancelCheckModal).find('#cancelConfirm-CancelBtn'),
		cancelConfirmBtn: $(modals.cancelModal.cancelSuccessModal).find('#cancelBtn')
	};

	var init= function(){
		
		$(form.title).each(function(){
			checkTextLength($(this), $(this).siblings('.left-text').find('.count')); 
		})
		
		$(form.contents).each(function(){
			checkTextLength($(this), $(this).siblings('.left-text').find('.count')); 
		})
		
		$(form.file).fileUploadSet();
		
	}
		
	var addEvent= function(){
		
		$(form.cancelBtn).on({
			click: function(){
				$(modals.cancelModal.cancelCheckModal).modal('show');
			}
		});
		
		$(modalsBtn.cancelCheckConfirmBtn).on({
			click: function(){
				$(modals.cancelModal.cancelSuccessModal).modal('show');
			}
		});
		
		$(form.submitBtn).on({
			click: function(){
				validation();
			}
		});
		
		$(modalsBtn.submitCheckConfirmBtn).on({
			click: function(){
				callInsert();
			}
		});
	}
		
	var validation= function(){
		$('.error-msg').hide();
		if($('.auto-validation-form').checkValidation()){
			
			$(modals.submitModal.submitCheckModal).modal('show');

	    }else{
	    	
	    	$('.field-block.error').find('.error-msg').show();
	    	
	    }
	}

	var callInsert = function(){
		var formData = new FormData();
		formData.append("report-name", $('#report-name').val());
		formData.append("report-email", $('#report-email').val());
		formData.append("report-tel", $('#report-tel').val());
		formData.append("report-type", $('#report-type option:selected').val());
		formData.append("report-title", $('#report-title').val());
		formData.append("report-contents", $('#report-contents').val());
		formData.append("agree-1", $('#agree-1').val());
		formData.append("agree-02", $('#agree-02').val());
		formData.append("requestVerificationToken", $('#requestVerificationToken').val());
		$('input.docImgUploadFile').each(function(){
			formData.append($(this).attr('name'), $(this)[0].files[0]);
		});
		formData.append("reporting-type", $('#reporting-type').val());
		formData.append("captchaCodeTextBox", $('#captchaCodeTextBox').val());
		formData.append("LBD_VCID_customizedCaptcha", $('#LBD_VCID_customizedCaptcha').val());
		formData.append("report-choose-reply", complaintsChooseReplyValue);
		
		/* LGEGMC-5323 start */
		if( $("#useNewCaptcha").length > 0 && $("#useNewCaptcha").val() == "Y"){
			formData.append("recaptchaPageType", $("#recaptchaPageType").val());
			
			if( !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
				var reCaptcha_Key = $('#siteKey').val();
				
	        	grecaptcha.enterprise.ready(function() {
	        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
	        			formData.append("verifyKey", btoa(token));
	        			formAnSubmit();
	        		});
	        	});
	        	
			}else if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
				formData.append("verifyKey", $("#verifyKey").val());
				formAnSubmit();
			}else{
				formAnSubmit();
			}
		}else{
			formAnSubmit();
		}
		
		var headers = {};
		headers["Content-type"] = "application/json";
		
		function formAnSubmit(){
			$.ajax({
				async: false,
				type:"POST",
				url: $('#reporting-form').attr('ajax-url'),
				processData: false,
				contentType: false,
				data: formData,
				success: function(data){
					var captcha = data.captcha;
					if(null != captcha && "" != captcha ){
						var errorMsg = captcha.error.captchaCodeTextBox;
						$('#captchaCodeTextBox').siblings('.error-msg').find('.ajax-msg').text(errorMsg);
						$('#captchaCodeTextBox').closet('.field-block').addClass('error');
						$('#captchaCodeTextBox').attr('aria-invalid', 'true');
		    			$('#captchaCodeTextBox').attr('aria-describedby', 'captchaCodeTextBoxError');
						$('#captchaCodeTextBox').siblings('.error-msg').find('.ajax-msg').show();
						$('#captchaCodeTextBox').siblings('.error-msg').show();
						$('#captchaCodeTextBox').focus();
						return false;
					}
					var result = data.result;
					if(result){
						$(modals.submitModal.submitSuccessModal).modal('show');
					}else{
						// LGEGMC-5375 start
						if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
							if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
								reload_recaptcha_wrapper();
							}
						}
						// LGEGMC-5375 end
					}
				},
				error: function(error){
				    console.log("error:", error);
				}
			});
		}
		/* LGEGMC-5323 end */
	}
	
	
	var cancelChangeHome = function(){
		$(modalsBtn.cancelConfirmBtn).on({
			click: function(){
				location.replace($(this).attr('move-url'));
			}
		});
	}
	
	var submitChangeHome = function(){
		$(modalsBtn.submitSuccessedBtn).on({
			click: function(){
				location.replace($(this).attr('move-url'));
			}
		});
	}
	
	var validationChk = function(){
			$(form.email).on('change', function(e){
				if($(form.email).val() == ''){
					$(form.emailRequiredErrorMsg).text($(form.emailInputEmptyErrorMsg).text());
					$(form.email).closest('div.field-block').addClass('error');
	    			$(form.email).attr('aria-invalid', 'true');
					$(form.email).attr('aria-describedby', 'report-idError');
					$(form.email).siblings('.error-msg').show();
					$(form.email).siblings('.error-msg').find('span.required').show();
					$(form.email).focus();
				}else{
					if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test($(form.email).val())){
						$(form.emailRequiredErrorMsg).text($(form.emailInputEmptyErrorMsg).text());
						$(form.email).closest('div.field-block').removeClass('error');
		    			$(form.email).attr('aria-invalid', '');
						$(form.email).attr('aria-describedby', '');
						$(form.email).siblings('.error-msg').hide();
					}else{
						$(form.emailRequiredErrorMsg).text($(form.emailInputErrorMsg).text());
						$(form.email).closest('div.field-block').addClass('error');
		    			$(form.email).attr('aria-invalid', 'true');
						$(form.email).attr('aria-describedby', 'report-idError');
						$(form.email).siblings('.error-msg').show();
						$(form.email).siblings('.error-msg').find('span.required').show();
						$(form.email).focus();
					}
				}
			});
			$(form.tel).on('change', function(e){
				if(/^([0-9])+$/.test($(form.tel).val())){
					$(form.telRequiredErrorMsg).text($(form.telInputEmptyErrorMsg).text());
					$(form.tel).closest('div.field-block').removeClass('error');
	    			$(form.tel).attr('aria-invalid', '');
					$(form.tel).attr('aria-describedby', '');
					$(form.tel).siblings('.error-msg').hide();
					$(form.tel).siblings('.error-msg').find('span.required').hide();
				}else{
					$(form.telRequiredErrorMsg).text($(form.telInputErrorMsg).text());
					$(form.tel).closest('div.field-block').addClass('error');
	    			$(form.tel).attr('aria-invalid', 'true');
					$(form.tel).attr('aria-describedby', 'report-idError');
					$(form.tel).siblings('.error-msg').show();
					$(form.tel).siblings('.error-msg').find('span.required').hide();
					$(form.tel).siblings('.error-msg').find('span.invalid-number').show();
					$(form.tel).focus();
				}
			});
			
			$(form.radio.chooseReply).on('change', function(e){
				complaintsChooseReplyValue = $(el).find('input[name="objects-1"]:checked').val();
			});			
		}
		
		init();
		addEvent();
		cancelChangeHome();
		submitChangeHome();
		validationChk();
		
});